<template>
  <div class="container1" v-wechat-title="$store.state.region.re_name +'-大赛-作品展示'">
    <div class="backtop">
      <img @click="back" src="@/assets/images/back_bai.png" alt="" />
      <span>作品展示</span>
    </div>
    <van-swipe class="my-swipe" indicator-color="white">
      <van-swipe-item v-for="item in obj.signup_image" :key="item.index">
        <van-image fit="contain" :src="item"></van-image>
      </van-swipe-item>
    </van-swipe>
    <div class="zuopinDetail">
      <div class="zuopinDetailList">
        <span>作品标题：{{ obj.signup_theme_name }}</span>
      </div>
      <div class="zuopinDetailList" v-if="obj.shoot_site != null">
        <span>拍摄地点：{{ obj.shoot_site }}</span>
      </div>
      <div class="zuopinDetailList">
        <span>作者署名：{{ obj.signup_username }}</span>
      </div>
      <div class="zuopinDetailList">
        <span>作品简介： {{ obj.signup_theme_name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { competionlist_detail } from "@/api/travel";
export default {
  data() {
    return {
      obj: {},
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
  created() {
    this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0
    });
    competionlist_detail(this.$route.params).then((res) => {
      this.obj = res.competion_onedata;
      this.$toast.clear()
    });
  },
};
</script>
<style scoped>
.container1 {
  background-color: #fff;
}
.backtop {
  background-color: #e95b2d;
  line-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  padding-right: 20px;
  position: relative;
}
.backtop span {
  color: #fff;
}
.backtop img {
  position: absolute;
  left: 10px;
  width: 30px;
  height: 30px;
}
.zuopinDetail {
  border-radius: 10px;
  margin: 20px 10px;
  padding: 20px;
  background-color: #ededed;
}
.zuopinDetailList {
  padding: 6px 0;
  font-size: 0.3rem;
  color: #6e6e6e;
}
</style>